import React from 'react'
import styled, { css } from 'styled-components'

const width = '1355'
const height = '1358'
const viewBox = '0 0 1355 1358'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g id="surface1" key="surface1" fill="#fff">
      <path d="M0 679 l0 -679 677.7 0 677.8 0 -242.6 242.7 c-154.8 154.9 -245.1 246.1 -249.6 251.8 -7.9 10.2 -18.3 25.2 -18.3 26.5 0 0.4 -0.4 1 -0.9 1.2 -1.3 0.4 -11.4 18.2 -18.2 31.8 -6.4 12.9 -14.5 34 -18.2 47.5 -3.7 13.3 -3.9 14.5 -2.5 14.5 0.9 0.1 0.7 0.5 -0.4 1.3 -1.6 1.2 -4.3 13.2 -7.9 34.7 -1.7 10.1 -2.2 52.5 -0.9 68 5.5 63.2 33.1 127.8 75.4 176.5 3.9 4.4 56.3 57.3 116.5 117.5 60.3 60.2 162.2 162.3 226.6 226.8 l117 117.2 -665.8 0 -665.7 0 0 -679z" />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconStrokeArrow'
})
